import React from "react"
export function Tick(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M6.807 14.512c.243.26.63.31.926.134l.096-.068 9.874-8.167-.952-1.161-9.333 7.72-3.873-4.15-1.092 1.028 4.354 4.664z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__tick"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
